import { SessionStorageKey, VIN_CHARACTERS_REGEX } from 'common/constants'
import { AlertDialog } from 'components/AlertDialog/AlertDialog'
import { Formik } from 'formik'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'
import BarcodeScannerIcon from 'icons/BarcodeScannerIcon'
import { useState, useRef } from 'react'
import { Button, Col, Form, InputGroup, Row } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { checkCamera } from 'utils/cameraUtils'
import * as Yup from 'yup'
import ScanVIN from 'components/Grounding/ScanVIN'

const schema = Yup.object({
  vin: Yup.string().length(17, 'Must be 17 characters')
})

export const GroundingImmediately = () => {
  const history = useHistory()
  const [modalShow, setModalShow] = useState(false)
  const [showScanner, setShowScanner] = useState(false)
  const [cameraError, setCameraError] = useState('')
  const scanButtonRef = useRef<HTMLButtonElement>(null)
  const { userInteraction } = useDtmAnalytics()

  const SubmitGrounding = (values) => {
    userInteraction('am:rmsus/my dashboard/dashboard: landing page:root:GROUND')
    sessionStorage.setItem(SessionStorageKey.GROUND_VIN, values.vin)
    history.push('/grounding')
  }

  const handleScanComplete = (scannedVin: string | null) => {
    setShowScanner(false)
    if (scannedVin) {
      sessionStorage.setItem(SessionStorageKey.GROUND_VIN, scannedVin)
      history.push('/grounding')
    }
  }

  const redirectToCamera = async () => {
    try {
      setCameraError('')
      const hasCamera = await checkCamera()

      if (hasCamera) {
        // On mobile, it's better to have a small delay before showing the scanner
        // This helps with the fullscreen API which often requires a user gesture
        setTimeout(() => {
          setShowScanner(true)
        }, 100)
      } else {
        setCameraError('No camera detected or permission denied')
        setModalShow(true)
      }
    } catch (error) {
      console.error('Camera access error:', error)
      setCameraError('Error accessing camera: ' + (error.message || 'Unknown error'))
      setModalShow(true)
    }
  }

  return (
    <Row>
      <AlertDialog
        title="Camera Access Error"
        description={cameraError || 'Please allow camera access to use this feature'}
        show={modalShow}
        onHide={() => setModalShow(false)}
        isConfirmation={false}
      />
      {showScanner && <ScanVIN onComplete={handleScanComplete} />}
      <Col>
        <Formik initialValues={{ vin: '' }} onSubmit={SubmitGrounding} validationSchema={schema}>
          {(props) => (
            <Form onSubmit={props.handleSubmit} onReset={props.handleReset}>
              <Row>
                <Form.Group className="col-lg-4 col-sm-8" controlId="vin">
                  <Row>
                    <Form.Label className="section-name" column sm="auto">
                      <h5>Enter VIN</h5>
                    </Form.Label>
                    <Col className="p-0">
                      <InputGroup>
                        <Form.Control
                          type="input"
                          placeholder="#17 digit VIN"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                          value={props.values.vin}
                          isInvalid={!!props.errors.vin}
                          onKeyDown={(e) => {
                            if (!VIN_CHARACTERS_REGEX.test(e.key)) {
                              e.preventDefault()
                            }
                          }}
                          maxLength={17}
                        />
                        <Button
                          className="search-option-scan-btn"
                          variant=""
                          onClick={redirectToCamera}
                          ref={scanButtonRef}
                        >
                          <BarcodeScannerIcon />
                          <label>SCAN</label>
                        </Button>
                      </InputGroup>
                      <Form.Control.Feedback tooltip={false} type="invalid">
                        {props.errors.vin}
                      </Form.Control.Feedback>
                    </Col>
                  </Row>
                </Form.Group>
                <Form.Group className="col-lg-4 col-sm-4 pl-0">
                  <Button type="submit" disabled={!(props.isValid && props.dirty)} className="mx-2">
                    GROUND
                  </Button>
                  <Button className="btn-secondary" type="reset">
                    CLEAR ALL
                  </Button>
                </Form.Group>
              </Row>
            </Form>
          )}
        </Formik>
      </Col>
    </Row>
  )
}
